import ERC720ABI from "../config/abi/erc20.json";
import ICO from "../config/abi/ICO.json";
import ERC20 from "../config/abi/erc20.json";
import { ethers } from "ethers";

const getContract = (abi, address, provider) => {
  return new ethers.Contract(address, abi, provider);
};

export const getErc720Contract = (address, provider) => {
  return getContract(ERC720ABI, address, provider);
};
export const getEr20Contract = (address, provider) => {
  return getContract(ERC20, address, provider);
};
export const getICOContract = (address, provider) => {
  return getContract(ICO, address, provider);
};

export const getEstimateGasPrice = (fun) => {
  return fun.estimateGas;
};
